<template>
  <!-- 新幻影 -->
  <section class="xhy" id="xhy"></section>
  <!-- <section class="xgj" id="xgj"><h2 v-html="xgjData.text"></h2><p v-html="getInt(xgjData.int)"></p><a href="https://qqsm.zygames.com/info/weapon.html" class="wqlb" target="_blank"><img src="https://cdn1.zygames.com/qqsm/Public/img/version/wqlb.png" alt=""></a></section> -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "xhyTab",
  props: ['xhyData'],
  data() {
    return {
    };
  },
  methods: {
    getInt(ints) { return ints.replace(/\r\n|\n|\r|【/g, '<h6 style="font-weight:bold;color:#f00;">').replace(/\r\n|\n|\r|】/g, "</h6>"); }
  },
  components: {
  },
};
</script>

<style lang="scss" scoped>
.xhy {
//   background: url("../../assets/img/xhyBg.jpg") no-repeat top center;
  background: url("../../assets/img/xhy.jpg") no-repeat top center;
  // height: 921px;
  height: 931px;
  position: relative;
  min-width: 1200px;
  border-top: 1px solid transparent;
  margin-top: -1px;

  h2 {
    width: 941px;
    margin: 166px auto 0;
    color: #c00;
    font: bold 42px/48px "微软雅黑", "Microsoft Yahei";
  }

  p {
    width: 800px;
    margin: 10px auto 0;
    font-size: 16px;
    color: #555;
    text-align: center;
    line-height: 1.75;
  }
  .wqlb {
    position: absolute;
    bottom: 60px;
    left: 50%;
    margin-left: -183px;
    filter: alpha(opacity=75);
    -moz-opacity: 0.75;
    opacity: 0.75;

    img {
      width: 365px;
      height: 67px;
      background-color: rgba(255, 255, 255, 0.5);
      -webkit-filter: drop-shadow(0 0 0 transparent);
      filter: drop-shadow(0 0 0 transparent);
    }

    &:hover {
      filter: alpha(opacity=100);
      -moz-opacity: 1;
      opacity: 1;

      img {
        box-shadow: 0 0 10px 1px #f66;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newItem/xhy.vue